import React, { Component } from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import { Redirect } from 'react-router-dom';

// Components
import ChangeOwnPasswordButton from './ChangeOwnPasswordButton';

// CSS
import './PageHeader.css';
import brandingStyles from '../branding/brandingStyles.js';

class PageHeader extends Component {

    constructor() {
        super();
        this.state = {
            username: JSON.parse(localStorage.getItem('scality-username')),
            usertype: JSON.parse(
              localStorage.getItem('scality-usertype')
            ) === 'superadmin' ?
            'Admin account' : null,
            showPasswordModal: false,
        };
        this.logout = this.logout.bind(this);
        this.openPasswordModal = this.openPasswordModal.bind(this);
    }

    logout() {
        localStorage.removeItem('scality-credentials');
        localStorage.removeItem('scality-usertype');
        localStorage.removeItem('scality-username');
        this.setState({ loggedOut: true });
    }

    openPasswordModal() {
        this.setState({ showPasswordModal: true });
    }

    render() {
        if (this.state.loggedOut) {
            return (<Redirect to="/login"/>);
        }

        let icon = <i></i>;
        if (this.props.facode) {
            icon = <i
              className={`fa fa-${this.props.facode}`}
              style={brandingStyles.mainColor}>
            </i>;
        }

        return (
            <div
              className="row page-header"
              style={brandingStyles.backgrounds.header}
            >
                <h2 className="page-title pull-left">
                    {icon}
                    <span> </span>
                    {this.props.title}
                </h2>
                <div className="pull-right">
                    <Dropdown id="user-dropdown">
                        <Dropdown.Toggle
                          bsStyle="default"
                          style={brandingStyles.buttons.default}
                          bsSize="small"
                        >
                            {this.state.usertype &&
                            <span
                              className="badge"
                              style={brandingStyles.mainColor}
                            >
                              {this.state.usertype}
                            </span>}
                            &nbsp;<i className="fa fa-user"></i>
                            &nbsp;{this.state.username}
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          className="super-colors dropdown-menu-right"
                          style={{ right: '53px' }}
                        >
                            <MenuItem eventKey="1" onClick={this.openPasswordModal}
                              className="change-password-btn">
                                <i className="fa fa-lock"></i>
                                &nbsp;Change Password</MenuItem>
                            <MenuItem divider />
                            <MenuItem eventKey="2" onClick={this.logout}
                              className="logout-btn">
                                <i className="fa fa-sign-out"></i>
                                &nbsp;Log out</MenuItem>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <ChangeOwnPasswordButton
                    showModal={this.state.showPasswordModal}
                    onClose={() => this.setState({ showPasswordModal: false })}
                />

            </div>
        );
    }
}

PageHeader.propTypes = {
    facode: PropTypes.string,
    title: PropTypes.string.isRequired,
};

export default PageHeader;



/** WEBPACK FOOTER **
 ** ./src/components/PageHeader.js
 **/